// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3t1Pf","bigColWidth":"Table_bigColWidth__36IDW","biggerColWidth":"Table_biggerColWidth__2OQ4L","row":"Table_row__14XCN","col":"Table_col__OUIdP"};